import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { URLs } from '../../constants/route'

export default function AuthenticatedRoute({
  path,
  component,
  accessToken,
  layout,
  exact,
  ...rest
}) {
  const C = component
  const Layout = layout
  return (
    <Route
      path={path}
      exact={exact}
      render={props =>
        accessToken ? (
          Layout ? (
            <Layout {...props} accessToken={accessToken} {...rest}>
              <C {...props} accessToken={accessToken} {...rest} />
            </Layout>
          ) : (
            <C {...props} accessToken={accessToken} {...rest} />
          )
        ) : (
          <Redirect
            to={`${URLs.LOGIN}?redirect=${props.location.pathname}${
              props.location.search
            }`}
          />
        )
      }
    />
  )
}

AuthenticatedRoute.propTypes = {
  accessToken: PropTypes.string.isRequired
}
